import { PAYMENT_METHODS } from '../../methods'

export const PROCESSOUT_ALTERNATE_GATEWAYS = {
  PAYPAL_REST: 'paypal-rest',
}

export const PROCESSOUT_ALTERNATE_PAYMENT_METHODS = {
  [PAYMENT_METHODS.PAYPAL]: PROCESSOUT_ALTERNATE_GATEWAYS.PAYPAL_REST,
}
